import { rag_v1 } from "../utils/axios-v2";

export interface CreateCheckoutRequest {
  name: string;
  slug: string;
  description?: string;
  plan_code: string;
}

export interface CreateCheckoutResponse {
  session_id: string;
  action: "create" | string;
  amount: string;
}

export interface GetCheckoutResponse {
  status: string;
  action: "create" | string;
  org_id: string | null;
}

export const checkoutApi = {
  async createCheckout(
    payload: CreateCheckoutRequest,
    signal?: AbortSignal,
  ): Promise<CreateCheckoutResponse> {
    const response = await rag_v1.post<CreateCheckoutResponse>(
      "/checkouts/",
      payload,
      { signal, timeout: 15000 },
    );
    return response.data;
  },

  async getCheckout(
    sessionId: string,
    signal?: AbortSignal,
  ): Promise<GetCheckoutResponse> {
    const response = await rag_v1.get<GetCheckoutResponse>(
      `/checkouts/${encodeURIComponent(sessionId)}`,
      { signal, timeout: 15000 },
    );
    return response.data;
  },
};
